import { CatButton } from '@blocks-react/components/Button';
import { HeaderStoreLocationButtonProps } from './types';
import { FC } from 'react';

export const HeaderStoreLocationButton: FC<HeaderStoreLocationButtonProps> = ({
  label,
  onClick,
}) => {
  return (
    <CatButton onClick={onClick} variant="primary" fullWidth={true}>
      {label}
    </CatButton>
  );
};
